export default __webpack_public_path__ + "static/media/react-Bootstrap.f0b8b6e4.svg";